import { viewDocument } from "../utiles/DocumentService";

const base64ToBlobUrl = (base64, fileName) => {
  const mimeType = fileName.toLowerCase().endsWith(".pdf")
    ? "application/pdf"
    : "image/jpeg";

  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const blob = new Blob([bytes], { type: mimeType });

  return URL.createObjectURL(blob);
};

export const fetchorgImageGeneral = async (logoName, code) => {
  const envCode = localStorage.getItem("envcode") || "Prod";
  const orgcode = localStorage.getItem("custCode") || "ptw";
  const folderPath = `Pvk/${orgcode}/org_${code}`;
  try {
    const response = await viewDocument({
      projectCode: "Ptw",
      envCode: envCode,
      folderPath: folderPath,
      fileName: logoName,
    });

    if (response?.cd === 1) {
      return "";
    }

    if (response) {
      return base64ToBlobUrl(response, logoName);
    }

    return "";
  } catch (err) {
    console.error("Error in fetchEmployeeImage:", err);
    return "";
  }
};
